import { each } from 'lodash';
import { api } from 'src/utils/api';

const find = id => api.get(`/companies/${id}`);

const updateOnImport = (id, params) => {
    const formData = new FormData();

    each(params, (value, key) => {
        if (params[key]) {
            formData.append(key, params[key]);
        }
    });

    return api.put(`/companies/import/${id}`, formData);
};

const update = (id, params) => {
    const formData = new FormData();

    each(params, (value, key) => {
        if (params[key]) {
            formData.append(key, params[key]);
        }
    });

    return api.put(`/companies/${id}`, formData);
};

const paralizeCompanyDebts = () => api.post('/companies/paralize-all-debts');

const startCompanyDebts = () => api.post('/companies/start-charge-all-debts');

const loadBusinessAreasRequest = () => api.get('/companies/business-areas');

const associatePaymentGatewayRequest = companyId => api.post('/payment-gateways/associate-company', {
    pk_company: companyId,
});

const findInformationByCnpj = document => api.get('/companies/receita', {
    params: {
        document,
    },
});
const bankStatement = params => api.get('/companies/bank-statement', {
    params
});


export {
    update,
    updateOnImport,
    find,
    paralizeCompanyDebts,
    startCompanyDebts,
    loadBusinessAreasRequest,
    associatePaymentGatewayRequest,
    findInformationByCnpj,
    bankStatement
};
